import { ERequestStatus } from '../requestStatus';

export interface IPageState {
  state: EPageState;
  status: ERequestStatus;
}

export enum EPageState {
  /** Форма Оставить заявку */
  RequestForm = 'requestFrom',
  /** Заявка успешно отправлена */
  RequestSent = 'requestSent',
}
